import Box, { type BoxProps } from '@components/Box';
import { cssJoin } from '@shared/util';
import { forwardRef } from 'react';

const ButtonGroup = forwardRef<HTMLDivElement, BoxProps>(
  ({ children, className, ...restProps }, ref) => (
    <Box
      className={cssJoin('button-group', className)}
      {...restProps}
      ref={ref}
    >
      {children}
    </Box>
  ),
);

ButtonGroup.displayName = 'ButtonGroup';

export default ButtonGroup;
